module.exports = __webpack_public_path__ + "img/close.87dec19f.svg";